const FALLBACK_APP_TITLE = '法律AI助手'

export const APP_TITLE = import.meta.env.VITE_APP_TITLE?.trim() || FALLBACK_APP_TITLE
